<template>
  <div class="container">
    <div class="frameContainer">
      <iframe
        id="labelIFrame"
        scrolling="auto"
        width="800"
        height="400"
        frameborder="0"
        style="background: #E9E9E9; display: inline;"
      ></iframe>
      <div class="printContainer">
        <el-button size="medium" type="primary" @click="printLabel">
          重新打印标签
        </el-button>
        <el-button v-if="!isRolePrinter" size="medium" style="display: block; margin: 10px 0;" @click="toFactoryLabelHistory">
          历史发货标签
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import {
  definedLabelType,
  definedFactoryLabelParameter,
} from '@/utils/defines';
import {
  bulkCreateBoxLabel,
  boxListGet,
} from '@/api/boxLabel';
import {
  bulkCreateLabel,
} from '@/api/label';
import {
  boxLabelTypes,
} from '@/utils/defines';
import {
  generateBinLevelValue,
} from '@/utils/label';
import {
  initYuanHengLabelFrame,
  initQiangLiJuCaiLabelFrame,
  initQiangLiJuCaiLabelV2Frame,
  initLiYaDeLabelFrame,
  initBaKeLabelFrame,
  initLeiManLabelFrame,
  initMeiKaLeLabelFrame,
  initYiShiDaLabelFrame,
  initJianHeLabelFrame,
  initJinLiXiangLabelFrame,
  initShiXinLabelFrame,
  printFactoryLabel,
  initQiangLiBoxLabelFrame,
  initLianJianLabelFrame,
  initWaferLabelFrame,
  initBoxLabelFrame,
  initWaferBoxLabelFrame,
  initBagLabelFrame,
  initMembraneLabelFrame,
  initCaseLabelFrame,
  initBagLabelCFrame,
  initModuleNoLabelFrame,
  initShiXinLabelV2Frame,
  initHuaLanLabelFrame,
  initJingTaiLabelFrame,
} from '@/utils/factory-label';
import {
  isNum,
  isValueEmpty,
} from '@/utils';

export default {
  name: "index",
  data() {
    return {
      printLabels: [],
      yuanHengBoxIndex: 1,
      printLabelType: undefined,
      printBoxLabelType: undefined,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
    isRolePrinter() {
      const {
        userInfo,
      } = this;
      return userInfo && userInfo.roles && userInfo.roles[0] && userInfo.roles[0].name === 'printer';
    }
  },
  mounted() {
    const {
      data,
    } = this.$route.query;
    if (data) {
      this.bulkCreate(decodeURIComponent(data));
    }
    document.oncontextmenu = function () {
      return false;
    };
    document.onkeydown = function (event) {
      let e = event || window.event;
      if (e && e.keyCode === 116) { // 禁止F5刷新
        return false;
      }
    };
    window.onbeforeunload = function (e) {
      let dialogText = '刷新会导致重复创建标签';
      e.returnValue = dialogText;
      return dialogText;
    };
  },
  methods: {
    async bulkCreate(data) {
      let printLabels;
      try {
        printLabels = JSON.parse(data);
      } catch (e) {
        // do nothing.
      }
      if (!printLabels || printLabels && printLabels.length === 0) {
        this.$message({
          type: 'error',
          message: '打印信息无效'
        });
        return;
      }
      const {
        boxLabels,
        labels,
        isQiangLiBatchNoSetUp,
        isQiangLiV2BatchNoSetUp,
      } = this.pickUpAllLabel(printLabels);
      this.generateYuanHengBatchNo(boxLabels, labels);
      // 强力批号，批号规则：IC56+生产日期（四位，年份的最后两位数字+月份两位数字）+流水号（三位数，每月从001~999，
      // 每个电路发一次货就是一个号,下月重新更新），如：同一天发了三个型号的产品，则IC56YYMM001，IC56YYMM002，IC56YYMM003，
      // 第二天发的型号不论和前一天的是否一致都为：IC56YYMM004，强力V2中间会多-，如IC56-YYMM-004
      if (boxLabels[definedLabelType.qiangli.val] || labels[definedLabelType.qiangli.val]) {
        if (!isQiangLiBatchNoSetUp) {
          try {
            const res = await boxListGet({
              page: 1,
              perpage: 10,
              labelType: definedLabelType.qiangli.val,
            });
            const data = res.data;
            const qiangLiLabels = data.info;
            this.generateQiangLiBatchNo(boxLabels, labels, qiangLiLabels, definedLabelType.qiangli.val, '');
          } catch (e) {
            this.printLabels = [];
            return;
          }
        }
      }
      if (boxLabels[definedLabelType.qiangli_v2.val] || labels[definedLabelType.qiangli_v2.val]) {
        if (!isQiangLiV2BatchNoSetUp) {
          try {
            const res = await boxListGet({
              page: 1,
              perpage: 10,
              labelType: definedLabelType.qiangli_v2.val,
            });
            const data = res.data;
            const qiangLiLabels = data.info;
            this.generateQiangLiBatchNo(boxLabels, labels, qiangLiLabels, definedLabelType.qiangli_v2.val, '-');
            if (boxLabels[definedLabelType.qiangli_box.val] || labels[definedLabelType.qiangli_box.val]) { // 处理强力v2和强力外箱加贴一起打的情况
              this.generateQiangLiBatchNo(boxLabels, labels, qiangLiLabels, definedLabelType.qiangli_box.val, '-');
            }
          } catch (e) {
            this.printLabels = [];
            return;
          }
        }
      } else if (boxLabels[definedLabelType.qiangli_box.val] || labels[definedLabelType.qiangli_box.val]) {
        if (!isQiangLiV2BatchNoSetUp) {
          try {
            const res = await boxListGet({
              page: 1,
              perpage: 10,
              labelType: definedLabelType.qiangli_box.val,
            });
            const data = res.data;
            const qiangLiLabels = data.info;
            this.generateQiangLiBatchNo(boxLabels, labels, qiangLiLabels, definedLabelType.qiangli_box.val, '-');
          } catch (e) {
            this.printLabels = [];
            return;
          }
        }
      }
      try {
        if (boxLabels && Object.keys(boxLabels).length > 0) {
          for (let [key, val] of Object.entries(boxLabels)) {
            await bulkCreateBoxLabel({
              labelType: Number.parseInt(key, 10),
              labelInfo: this.filterParameter(val, key),
            });
            if (labels[key] && labels[key].length > 0) {
              await bulkCreateLabel({
                labelType: Number.parseInt(key, 10),
                labelInfo: this.filterParameter(labels[key], key),
              });
            }
          }
        } else if (labels && Object.keys(labels).length > 0) {
          for (let key of Object.keys(labels)) {
            await bulkCreateLabel({
              labelType: Number.parseInt(key, 10),
              labelInfo: this.filterParameter(labels[key], key),
            });
          }
        }
        this.printLabel();
      } catch (e) {
        this.printLabels = [];
        // do nothing.
      }
    },
    pickUpAllLabel(printLabels) {
      const boxLabels = {};
      const labels = {};
      let labelType, boxLabelType, isBoxLabel, reserve, yuanHengBox, boxLabel, boxLabelCopy, label;
      this.printLabels = [];
      let isQiangLiBatchNoSetUp = false, isQiangLiV2BatchNoSetUp = false;
      for (let row of printLabels) {
        labelType = row.labelType;
        boxLabelType = row.boxLabelType;
        this.printLabelType = labelType;
        this.printBoxLabelType = boxLabelType;
        reserve = isValueEmpty(row.reserve) ? '' : String(row.reserve);
        if (labelType === definedLabelType.yuanheng.val) {
          yuanHengBox = String(this.yuanHengBoxIndex);
          if (yuanHengBox.length <= 2) {
            reserve = '#' + yuanHengBox.padStart(3, '0');
          } else {
            reserve = '#' + yuanHengBox;
          }
          this.yuanHengBoxIndex++;
        } else if (labelType === definedLabelType.qiangli.val) {
          if (/^IC56/.test(row.trackingNo)) { // 强力标签批号格式如IC56YYMM004
            isQiangLiBatchNoSetUp = true;
          }
        } else if (labelType === definedLabelType.qiangli_v2.val || labelType === definedLabelType.qiangli_box.val) {
          if (/^IC56-/.test(row.trackingNo)) { // 强力V2标签批号格式如IC56-YYMM-004
            isQiangLiV2BatchNoSetUp = true;
          }
        } else if (labelType === definedLabelType.meikale.val) { // 美卡乐要求去掉右上角的A
          reserve = '';
        }
        isBoxLabel = boxLabelType === boxLabelTypes.boxLabel.val;
        if (isBoxLabel) {
          if (!boxLabels[labelType]) {
            boxLabels[labelType] = [];
          }
          boxLabel = {
            productName: row.productName,
            chipName: row.chipName,
            processingOrderNo: row.processingOrderNo,
            purchaseOrderNo: row.purchaseOrderNo,
            customPartNo: row.customPartNo,
            partNo: row.partNo,
            dateCode: row.dateCode,
            trackingNo: row.trackingNo,
            qty: row.qty,
            reserve: reserve,
            grossWeight: row.grossWeight,
            lotNo: row.lotNo,
            packageType: row.packageType,
            marking: row.marking,
            netWeight: row.netWeight,
            binLevel: row.binLevel,
          };
          boxLabels[labelType].push(boxLabel);
          boxLabelCopy = {...boxLabel, labelType, printCount: row.printCount};
          if (row.detail && row.detail.length > 0) {
            boxLabelCopy.detail = [];
            for (let val of row.detail) {
              if (!labels[labelType]) {
                labels[labelType] = [];
              }
              label = {
                productName: row.productName,
                chipName: row.chipName,
                processingOrderNo: row.processingOrderNo,
                purchaseOrderNo: row.purchaseOrderNo,
                customPartNo: row.customPartNo,
                partNo: row.partNo,
                dateCode: row.dateCode,
                reserve: reserve,
                lotNo: row.lotNo,
                marking: row.marking,
                packageType: row.packageType,
                binLevel: row.binLevel,

                trackingNo: val.trackingNo,
                qty: val.qty,
              };
              labels[labelType].push(label);
              boxLabelCopy.detail.push({...label, printCount: val.printCount});
            }
          }
          this.printLabels.push(boxLabelCopy);
        } else {
          if (!labels[labelType]) {
            labels[labelType] = [];
          }
          label = {
            productName: row.productName,
            chipName: row.chipName,
            processingOrderNo: row.processingOrderNo,
            purchaseOrderNo: row.purchaseOrderNo,
            customPartNo: row.customPartNo,
            partNo: row.partNo,
            dateCode: row.dateCode,
            reserve: reserve,
            lotNo: row.lotNo,
            marking: row.marking,
            packageType: row.packageType,
            binLevel: row.binLevel,

            trackingNo: row.trackingNo,
            qty: row.qty,
          };
          labels[labelType].push(label);
          this.printLabels.push({...label, labelType, printCount: row.printCount});
        }
      }
      return {boxLabels, labels, isQiangLiBatchNoSetUp, isQiangLiV2BatchNoSetUp};
    },
    generateYuanHengBatchNo(boxLabels, labels) {
      if (boxLabels[definedLabelType.yuanheng.val] || labels[definedLabelType.yuanheng.val]) {
        let batchNo = '', dateCodeBatch = '';
        const manufacturerLotNo = 'HZSX20160722';
        for (let row of this.printLabels) {
          if (row.labelType === definedLabelType.yuanheng.val) {
            dateCodeBatch = moment(row.dateCode).format('YYYYMMDD');
            batchNo = `LOT/${row.processingOrderNo}/${row.purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${row.reserve.replace('#', '')}`;
            row.trackingNo = batchNo;
            if (row.detail && row.detail.length > 0) {
              for (let val of row.detail) {
                dateCodeBatch = moment(val.dateCode).format('YYYYMMDD');
                batchNo = `LOT/${val.processingOrderNo}/${val.purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${val.reserve.replace('#', '')}`;
                val.trackingNo = batchNo;
              }
            }
          }
        }
        if (boxLabels[definedLabelType.yuanheng.val]) {
          for (let row of boxLabels[definedLabelType.yuanheng.val]) {
            dateCodeBatch = moment(row.dateCode).format('YYYYMMDD');
            batchNo = `LOT/${row.processingOrderNo}/${row.purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${row.reserve.replace('#', '')}`;
            row.trackingNo = batchNo;
          }
        }
        if (labels[definedLabelType.yuanheng.val]) {
          for (let row of labels[definedLabelType.yuanheng.val]) {
            dateCodeBatch = moment(row.dateCode).format('YYYYMMDD');
            batchNo = `LOT/${row.processingOrderNo}/${row.purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${row.reserve.replace('#', '')}`;
            row.trackingNo = batchNo;
          }
        }
      }
    },
    generateQiangLiBatchNo(boxLabels, labels, qiangLiLabels, labelType, connector) {
      let boxLabelsDateCode;
      if (boxLabels[labelType]) {
        boxLabelsDateCode = boxLabels[labelType][0].dateCode;
      } else if (labels[labelType]) {
        boxLabelsDateCode = labels[labelType][0].dateCode;
      }
      const qiangLiDateCode = moment(boxLabelsDateCode).format('YYMM');
      let qiangLiBatchNo = `IC56${connector}${qiangLiDateCode}${connector}001`;
      if (qiangLiLabels && qiangLiLabels.length > 0) {
        let trackingNo = qiangLiLabels[0].trackingNo;
        trackingNo = isValueEmpty(trackingNo) || trackingNo === null ? '' : trackingNo;
        const dateCode = qiangLiLabels[0].dateCode;
        qiangLiBatchNo = trackingNo.substring(trackingNo.length - 3);
        const isSameMonth = moment(boxLabelsDateCode).format('YYYYMM') === moment(dateCode).format('YYYYMM');
        if (isSameMonth) {
          if (isNum(qiangLiBatchNo)) {
            qiangLiBatchNo = (Number.parseInt(qiangLiBatchNo, 10) + 1) % 1000;
            if (qiangLiBatchNo === 0) {
              qiangLiBatchNo = 1;
            }
            qiangLiBatchNo = `IC56${connector}${qiangLiDateCode}${connector}${String(qiangLiBatchNo).padStart(3, '0')}`;
          } else {
            qiangLiBatchNo = `IC56${connector}${qiangLiDateCode}${connector}001`;
          }
        } else {
          qiangLiBatchNo = `IC56${connector}${qiangLiDateCode}${connector}001`;
        }
      }
      for (let row of this.printLabels) {
        if (row.labelType === labelType) {
          row.trackingNo = qiangLiBatchNo;
          if (row.detail && row.detail.length > 0) {
            for (let val of row.detail) {
              val.trackingNo = `${qiangLiBatchNo}${!isValueEmpty(val.binLevel) ? '-B' + val.binLevel : ''}`;
            }
          }
        }
      }
      if (boxLabels[labelType]) {
        for (let row of boxLabels[labelType]) {
          row.trackingNo = `${qiangLiBatchNo}${!isValueEmpty(row.binLevel) ? '-B' + row.binLevel : ''}`;
        }
      }
      if (labels[labelType]) {
        for (let row of labels[labelType]) {
          row.trackingNo = `${qiangLiBatchNo}${!isValueEmpty(row.binLevel) ? '-B' + row.binLevel : ''}`;
        }
      }
    },
    printLabel() {
      let index = 0;
      const printLabels = this.printLabels;
      if (!printLabels || printLabels && printLabels.length === 0) {
        const {
          data,
        } = this.$route.query;
        if (data) {
          this.bulkCreate(decodeURIComponent(data));
        }
        return;
      }
      let iframe = document.getElementById('labelIFrame');
      let labelType, printCount;
      for (let row of printLabels) {
        labelType = row.labelType;
        printCount = row.printCount || 1;
        for (let i = 0; i < printCount; i++) {
          iframe = this.initLabel(iframe, labelType, row, index);
          index++;
        }
        if (row.detail && row.detail.length > 0) {
          for (let val of row.detail) {
            printCount = val.printCount || 1;
            for (let i = 0; i < printCount; i++) {
              iframe = this.initLabel(iframe, labelType, val, index);
              index++;
            }
          }
        }
      }
      iframe.contentWindow.document.close();
      printFactoryLabel(iframe);
    },
    initLabel(iframe, labelType, val, index) {
      switch (labelType) {
        case definedLabelType.yuanheng.val:
          iframe = initYuanHengLabelFrame({
            iframe,
            processingOrderNo: val.processingOrderNo,
            purchaseOrderNo: val.purchaseOrderNo,
            materialNo: val.customPartNo,
            specificationNo: val.partNo,
            deliveryDate: val.dateCode,
            count: val.qty,
            boxNo: val.reserve,
            index,
          });
          break;
        case definedLabelType.qiangli.val:
          iframe = initQiangLiJuCaiLabelFrame({
            iframe,
            partNo: val.partNo,
            materialNo: val.customPartNo,
            orderNo: val.purchaseOrderNo,
            count: val.qty,
            weight: val.grossWeight,
            deliveryDate: val.dateCode,
            batchNo: val.trackingNo,
            index,
          });
          break;
        case definedLabelType.qiangli_v2.val:
          iframe = initQiangLiJuCaiLabelV2Frame({
            iframe,
            machineHandNo: val.processingOrderNo,
            partNo: val.partNo,
            materialNo: val.customPartNo,
            count: val.qty,
            deliveryDate: val.dateCode,
            trackingNo: val.trackingNo,
            index,
          });
          break;
        case definedLabelType.liyade.val:
          iframe = initLiYaDeLabelFrame({
            iframe,
            orderNo: val.purchaseOrderNo,
            materialNo: val.customPartNo,
            materialDescription: val.partNo,
            count: val.qty,
            deliveryDate: val.dateCode,
            productionBatch: val.lotNo,
            index,
          });
          break;
        case definedLabelType.liyadedianshi.val:
          iframe = initLiYaDeLabelFrame({
            iframe,
            orderNo: val.purchaseOrderNo,
            materialNo: val.customPartNo,
            materialDescription: val.partNo,
            count: val.qty,
            deliveryDate: val.dateCode,
            productionBatch: val.lotNo,
            index,
          });
          break;
        case definedLabelType.yishida.val:
          iframe = initYiShiDaLabelFrame({
            iframe,
            orderNo: val.purchaseOrderNo,
            customerMaterialNo: val.customPartNo,
            count: val.qty,
            index,
          });
          break;
        case definedLabelType.bake.val:
          iframe = initBaKeLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            trackingNo: val.trackingNo,
            dateCode: val.dateCode,
            packageType: val.packageType,
            result: 'PASSED',
            marking: val.marking,
            grossWeight: val.grossWeight,
            netWeight: val.netWeight,
            binLevelExplain: val.reserve,
            customerMaterialNo: val.customPartNo,
            index,
          });
          break;
        case definedLabelType.leiman.val:
          iframe = initLeiManLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            trackingNo: val.trackingNo,
            dateCode: val.dateCode,
            packageType: val.packageType,
            result: 'PASSED',
            marking: val.marking,
            grossWeight: val.grossWeight,
            netWeight: val.netWeight,
            binLevelExplain: val.reserve,
            customerMaterialNo: val.customPartNo,
            index,
          });
          break;
        case definedLabelType.jianhe.val:
          iframe = initJianHeLabelFrame({
            iframe,
            materialNo: val.customPartNo,
            materialName: val.partNo,
            contractNo: val.purchaseOrderNo,
            deliveryDate: val.dateCode,
            index,
          });
          break;
        case definedLabelType.meikale.val:
          iframe = initMeiKaLeLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            trackingNo: val.trackingNo,
            dateCode: val.dateCode,
            packageType: val.packageType,
            result: 'PASSED',
            marking: val.marking,
            grossWeight: val.grossWeight,
            netWeight: val.netWeight,
            binLevelExplain: val.reserve,
            customerMaterialNo: val.customPartNo,
            index,
          });
          break;
        case definedLabelType.jinlixiang.val:
          iframe = initJinLiXiangLabelFrame({
            iframe,
            orderNo: val.purchaseOrderNo,
            materialNo: val.customPartNo,
            materialDescription: val.partNo,
            count: val.qty,
            deliveryDate: val.dateCode,
            productionBatch: val.lotNo,
            index,
          });
          break;
        case definedLabelType.shixin2.val:
          const {
            partNo,
            chipName,
            binLevel,
          } = val;
          let binLevelValue = generateBinLevelValue({partNo, chipName, binLevel});
          iframe = initShiXinLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            trackingNo: val.trackingNo,
            dateCode: val.dateCode,
            packageType: val.packageType,
            result: 'PASSED',
            marking: val.marking,
            grossWeight: val.grossWeight,
            netWeight: val.netWeight,
            binLevelExplain: binLevelValue,
            index,
          });
          break;
        case definedLabelType.qiangli_box.val:
          if (val.reserve) {
            try {
              let reserve = JSON.parse(val.reserve);
              let info = reserve.info;
              let reserveInfo = [];
              let i = 0;
              let lotNoIndex = 0;
              for (let v of info) {
                i++;
                reserveInfo.push(v);
                if (i % 4 === 0) {
                  lotNoIndex++;
                  iframe = initQiangLiBoxLabelFrame({
                    iframe,
                    partNo: val.partNo,
                    lotNo: val.lotNo,
                    trackingNo: val.trackingNo,
                    reserveInfo: reserveInfo,
                    index: i > 4 ? index + 1 : index, // 标签分页
                    lotNoIndex: info.length > 4 ? lotNoIndex : '',
                  });
                  reserveInfo = [];
                  index++;
                }
              }
              if (reserveInfo.length > 0) {
                lotNoIndex++;
                iframe = initQiangLiBoxLabelFrame({
                  iframe,
                  partNo: val.partNo,
                  lotNo: val.lotNo,
                  trackingNo: val.trackingNo,
                  reserveInfo: reserveInfo,
                  index: i > 4 ? index + 1 : index, // 标签分页
                  lotNoIndex: info.length > 4 ? lotNoIndex : undefined,
                });
                index++;
              }
            } catch (e) {
              // do nothing.
            }
          }
          break;
        case definedLabelType.lianjian.val:
          iframe = initLianJianLabelFrame({
            iframe,
            materialNo: val.customPartNo,
            materialName: val.partNo,
            contractNo: val.purchaseOrderNo,
            deliveryDate: val.dateCode,
            index,
          });
          break;
        case definedLabelType.jingyuan_dai.val:
          iframe = initWaferLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            waferCount: val.qty,
            waferNo: val.customPartNo,
            prop: val.marking,
            dateCode: val.dateCode,
            qty: val.reserve,
            trackingNo: val.trackingNo,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.jingyuan_pian.val:
          iframe = initBoxLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            waferNo: val.marking,
            qty: val.reserve,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.jingyuan_box.val:
          iframe = initWaferBoxLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            waferCount: val.qty,
            dateCode: val.dateCode,
            qty: val.reserve,
            trackingNo: val.trackingNo,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.bag.val:
          iframe = initBagLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            waferNo: val.customPartNo,
            type: val.marking,
            note: val.reserve,
            dateCode: val.dateCode,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.membrane.val:
          iframe = initMembraneLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            waferNo: val.customPartNo,
            qty: val.qty,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.case.val:
          iframe = initCaseLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            waferNo: val.customPartNo,
            type: val.marking,
            note: val.reserve,
            dateCode: val.dateCode,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.bagC.val:
          iframe = initBagLabelCFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            waferNo: val.customPartNo,
            type: val.marking,
            note: val.reserve,
            dateCode: val.dateCode,
            binLevelExplain: val.packageType,
            index,
          });
          break;
        case definedLabelType.moduleNo.val:
          iframe = initModuleNoLabelFrame({
            iframe,
            moduleNo: val.reserve,
            moduleNoQrCode: val.packageType,
            index,
          });
          break;
        case definedLabelType.shixinV2.val:
          let binLevelValueV2 = generateBinLevelValue({partNo: val.partNo, chipName: val.chipName, binLevel: val.binLevel});
          iframe = initShiXinLabelV2Frame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            trackingNo: val.trackingNo,
            dateCode: val.dateCode,
            packageType: val.packageType,
            result: val.reserve,
            marking: val.marking,
            grossWeight: val.grossWeight,
            netWeight: val.netWeight,
            binLevelExplain: binLevelValueV2,
            remark: val.customPartNo,
            index,
          });
          break;
        case definedLabelType.hualan.val:
          iframe = initHuaLanLabelFrame({
            iframe,
            partNo: val.partNo,
            lotNo: val.lotNo,
            qty: val.qty,
            waferNo: val.customPartNo,
            note: val.reserve,
            prop: val.marking,
            type: val.packageType,
            dateCode: val.dateCode,
            cn: val.purchaseOrderNo,
            die: val.processingOrderNo,
            index,
          });
          break;
        case definedLabelType.jingtai.val:
          iframe = initJingTaiLabelFrame({
            iframe,
            supplierCode: val.reserve,
            materialCode: val.customPartNo,
            materialName: val.partNo,
            specModel: val.processingOrderNo,
            qty: val.qty,
            orderNo: val.purchaseOrderNo,
            dateCode: val.dateCode,
            index,
          });
          break;  
        default:
          break;
      }
      return iframe;
    },
    toFactoryLabelHistory() {
      const {href} = this.$router.resolve({
        path: `/factory-label-history/list`,
        query: {
          label: this.printBoxLabelType || '',
          labelType: this.printLabelType || ''
        },
      });
      window.open(href, '_blank');
    },
    filterParameter(val, key) {
      const filterParameter = [];
      const data = val || [];
      const labelParameter = definedFactoryLabelParameter[String(key)] || [];
      let parameter = {};
      for (let row of data) {
        parameter = {};
        for (let [k, v] of Object.entries(row)) {
          if (labelParameter.includes(k)) {
            parameter[k] = v;
          }
        }
        filterParameter.push(parameter);
      }
      return filterParameter;
    }
  }
}
</script>

<style scoped>
.container {
  text-align: center;
}

.frameContainer {
  position: relative;
  margin: 20px auto;
}

.printContainer {
  position: absolute;
  margin-left: 10px;
  top: 0;
  display: inline-block;
  text-align: start;
}
</style>
